import { useReactiveVar } from '@apollo/client'
import { Button } from '@radix-ui/themes'
import type { SignUpSource } from 'shared/analytics/events'
import { DataTestIDs } from 'shared/constants'
import { RadixText } from 'shared/ui'
import { useAuthSession } from '../hooks/use-auth-session'
import { isPrivyExchangingVar, isPrivyReadyVar } from '../store'

interface Props {
  /** Where the button is, for `sign_up_started` (FE-321). */
  source: SignUpSource
}

/**
 * Header entry point for the Privy flow: opens the Privy login modal.
 * The full login screen with its own branding is FE-302.
 */
export const PrivySignInButton: React.FC<Props> = ({ source }) => {
  const isReady = useReactiveVar(isPrivyReadyVar)
  const isExchanging = useReactiveVar(isPrivyExchangingVar)
  const { signIn } = useAuthSession()

  return (
    <Button
      onClick={() => signIn(source)}
      disabled={!isReady || isExchanging}
      my={'0'}
      mx={'2'}
      size={'3'}
      color={'yellow'}
      type={'button'}
      data-testid={DataTestIDs.buttonPrivySignIn}
    >
      <RadixText
        weight={'bold'}
        size={'2'}
      >
        {isExchanging ? 'Signing in...' : 'Sign in'}
      </RadixText>
    </Button>
  )
}
